export default [
  {
    path: '/cut-plan/edit',
    name: 'cut-plan-edit',
    component: () => import(/* webpackChunkName: "index-routes" */ '@/views/Inventory/CutPlans/CutPlanEdit'),
    meta: { permission: 'api.view_cutplan' }
  },
  {
    path: '/inventory-list',
    component: () => import(/* webpackChunkName: "index-routes" */ '@/views/Inventory/InventoryParent'),
    children: [
      {
        path: '',
        name: 'inventory-list',
        component: () => import(/* webpackChunkName: "index-routes" */ '@/views/Inventory/InventoryList'),
        meta: { permission: 'api.view_inventory' }
      },
      {
        path: '/cut-plan-list',
        name: 'cut-plan-list',
        component: () => import(/* webpackChunkName: "index-routes" */ '@/views/Inventory/CutPlans/CutPlanList'),
        meta: { permission: 'api.view_cutplan' }
      },
      {
        path: '/cut-plan/:id',
        name: 'cut-plan-view',
        component: () => import(/* webpackChunkName: "index-routes" */ '@/views/Inventory/CutPlans/CutPlanView'),
        meta: { permission: 'api.view_cutplan' }
      },
      {
        path: '/shredding-operations',
        name: 'Shredding Operations',
        component: () => import(/* webpackChunkName: "index-routes" */ '@/views/Inventory/ShreddingOperations/ShreddingOperationsView'),
        meta: { permission: 'api.view_cutplan' }
      }
    ]
  },
  {
    path: '/inventory/:id',
    name: 'inventory',
    component: () => import(/* webpackChunkName: "index-routes" */ '@/views/Inventory/Inventory'),
    reverse: 'inventories-single'
  }
]
